// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.padlock-button[data-v-6160a37c]::before {\n  position: absolute;\n  right: 18px;\n  font-size: 16px;\n}\n.position-relative[data-v-6160a37c] {\n  position: relative;\n}\n.max-width[data-v-6160a37c] {\n  max-width: 587px;\n}\n", ""]);
// Exports
module.exports = exports;
